export enum CourseStatus {
  PENDING = "Pending",
  FINISHED = "Finished",
  IN_PROGRESS = "In Progress",
}

export type Course = {
  title: string;
  thumbnailUrl: string;
  courseUrl: string;
  examPoints?: number;
  coursePoints?: number;
  status: CourseStatus;
  points: number;
  /** Set when list comes from sg-pdc-api (stable React key) */
  pdcCourseId?: number;
};

export type CompletedCourses = {
  completedCourses: number;
  coursesWithProgress?: number;
  totalCourses?: number;
};
